<template>
  <div class='plus-form default-form'>
    <ValidationObserver ref='form'>
      <div class='row'>
        <label>Связки</label>
        <textarea
          v-model='model.sourceString'
          rows='10'
          placeholder='VIN;Промокод'
        />
      </div>
    </ValidationObserver>
  </div>
</template>


<script>
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'plus-form',

  components: {
    ValidationObserver,
  },

  props: {
    model: Object,
  },

  methods: {
    async validate() {
      return await this.$refs.form.validate();
    },
  },
};
</script>
